import axios from '../../api/common/axios';
import { PREMIUM_PLAN as premiumPlanTypes } from '../mutation-types';
import premiumApi from '../../api/premium';

// State
const state = () => ({
  plan: {},
  type: '',
  canGetBonus: true
});
// Actions
const actions = {
  /*
   * 契約できるPremiumPlanを取得する
   * @param {String} payload.channelId - PremiumChannels._id
   * @param {String} payload.paymentMethod - 決済方法 stripe, paypal, etc...
   * @param {String} payload.fingerprint - Credit Cardのfingerprint stripeの場合必須
   * @param {String} payload.paypalPayerId - PayPal Payer ID paypalの場合必須
   * @param
   */
  fetchPlan({
    commit
  }, payload) {
    return axios
      .post('/premium/plan', {
        channel: payload.channelId,
        planSlug: payload.planSlug,
        method: payload.paymentMethod,
        fingerprint: payload.fingerprint,
        paypalPayerId: payload.paypalPayerId,
        _csrf: payload._csrf
      })
      .then(function(res) {
        const {
          data
        } = res;
        if (data && data.status !== 'ok') {
          return Promise.reject(data);
        }
        commit(premiumPlanTypes.UPDATE_PLAN, {
          plan: data.plan,
          type: data.type,
          canGetBonus: data.can_get_bonus
        });
      })
      .catch((err) =>
        Promise.reject((err.errors && err.errors.general) || 'Network error')
      );
  },

  /*
  Premiumに入会する
  @param {String} payload.wishlistId
  @param {String} payload.channelId - PremiumChannels._id
  @param {String} payload.planSlug - PremiumPlans.unique_slug
  */
  join({
    state
  }, payload) {
    return new Promise(function(resolve, reject) {
      premiumApi.join({
          wishlistId: payload.wishlistId,
          channelId: payload.channelId,
          planSlug: payload.planSlug || state.plan.unique_slug
        },
        function(err, res) {
          if (err) {
            return reject(err);
          }
          resolve(res);
        }
      );
    });
  }
};

// Mutations
const mutations = {
  [premiumPlanTypes.UPDATE_PLAN](state, payload) {
    state.plan = payload.plan;
    state.type = payload.type;
    state.canGetBonus = payload.canGetBonus;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
